import { clickedActionWireOptions } from '@/lib/chat/clickedActionPresentation'

interface StandardMessageState {
  activeConversationId: string | null
  addMessage: (message: {
    id: string
    conversationId: string
    content: string
    role: 'user'
    timestamp: number
    status: 'sending'
    displayText: string
  }) => void
  clearInactivityNotice: () => void
  clearStreamError: () => void
  removeMessage: (id: string) => void
}

export async function sendStandardMessage(
  getChatState: () => StandardMessageState,
  text: string,
  source: string,
  stableMessageId?: string,
  clickLabel?: string,
): Promise<boolean> {
  const { useConnectionStore } = await import('./connectionStore')
  const { sendRaw, state: connectionState, transport } = useConnectionStore.getState()
  const restFallback = connectionState === 'DEGRADED' && transport === 'rest'
  if (connectionState !== 'CONNECTED' && connectionState !== 'RECONNECTING' && !restFallback) {
    console.warn('[ChatStore] sendStandardMessage: not connected, dropping message')
    return false
  }

  const state = getChatState()
  const conversationId = state.activeConversationId ?? ''
  const messageId = stableMessageId ?? crypto.randomUUID()
  state.clearStreamError()
  state.clearInactivityNotice()

  if (import.meta.env.DEV) {
    console.debug('[ChatStore] sendStandardMessage source:', source)
  }

  state.addMessage({
    id: messageId,
    conversationId,
    content: text,
    role: 'user',
    timestamp: Date.now(),
    status: 'sending',
    displayText: clickLabel ?? text,
  })

  const sent = clickLabel
    ? sendRaw(conversationId, text, messageId, clickedActionWireOptions({ displayText: clickLabel }))
    : sendRaw(conversationId, text, messageId)
  if (!sent) getChatState().removeMessage(messageId)
  return sent
}
